import { useEffect, useRef } from "react";

// Fine "sweat speck" particles rising slowly over the hero — pure canvas, ~70 nodes.
export const HeroParticles = () => {
  const ref = useRef(null);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    const canvas = ref.current;
    const ctx = canvas.getContext("2d");
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    const COUNT = 70;
    let w = 0;
    let h = 0;
    let raf;
    let parts = [];

    const resize = () => {
      w = canvas.clientWidth;
      h = canvas.clientHeight;
      canvas.width = w * dpr;
      canvas.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    };

    const spawn = (anywhere) => ({
      x: Math.random() * w,
      y: anywhere ? Math.random() * h : h + 12,
      r: 0.4 + Math.random() * 1.6,
      vy: 0.12 + Math.random() * 0.35,
      sway: 8 + Math.random() * 18,
      phase: Math.random() * Math.PI * 2,
      spin: 0.006 + Math.random() * 0.014,
      a: 0.05 + Math.random() * 0.2,
    });

    resize();
    parts = Array.from({ length: COUNT }, () => spawn(true));

    const tick = () => {
      ctx.clearRect(0, 0, w, h);
      for (const p of parts) {
        p.y -= p.vy;
        p.phase += p.spin;
        if (p.y < -12) Object.assign(p, spawn(false));
        const x = p.x + Math.sin(p.phase) * p.sway;
        ctx.beginPath();
        ctx.arc(x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(157, 183, 205, ${p.a})`;
        ctx.fill();
      }
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    window.addEventListener("resize", resize);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
    };
  }, []);

  return (
    <canvas
      ref={ref}
      data-testid="hero-particles"
      aria-hidden="true"
      className="absolute inset-0 w-full h-full pointer-events-none"
    />
  );
};
